import { SolViewId } from '@sol/components';
import { AutomationActionEditViewOptions } from '../components/view/asm-view-edit-automation-action/asm-view-edit-automation-action.component';

export class AsmAutomationViewId {
  public static readonly automationActionEdit =
    SolViewId.of<AutomationActionEditViewOptions>('asm.automationActionEdit');
}
